import * as React from 'react';
import { memo, SVGProps } from 'react';

function WarningIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" {...props}>
      <path
        fill="#fff"
        fillRule="evenodd"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m9.806 4.821-7 12.962A2.5 2.5 0 0 0 5 21.48h14a2.5 2.5 0 0 0 2.194-3.697l-7-12.962a2.5 2.5 0 0 0-4.388 0Z"
        clipRule="evenodd"
      />
      <path fill="#BD0000" fillRule="evenodd" d="M12 8.483v7.062-7.062Z" clipRule="evenodd" />
      <path stroke="#BD0000" strokeLinecap="round" strokeLinejoin="round" d="M12 8.483v7.062" />
      <circle cx={12} cy={17.983} r={0.125} fill="#BD0000" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={12} cy={17.983} r={0.621} fill="#BD0000" />
    </svg>
  );
}

export function WarningIconWithBackground(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg" width={20} height={19} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.6613 1.64131L7.6681 1.62922C8.91973 -0.525449 11.113 -0.563265 12.3385 1.63708L19.4895 14.7756C20.7251 16.9616 19.6297 18.9866 17.1542 18.9866H2.8467C0.375181 18.9866 -0.724452 16.9594 0.507551 14.7826L7.6613 1.64131ZM10.0004 4.98662C10.2682 4.98662 10.4868 5.19711 10.4998 5.46166L10.5004 5.48662V12.5491C10.5004 12.8253 10.2766 13.0491 10.0004 13.0491C9.73267 13.0491 9.51406 12.8386 9.50106 12.5741L9.50045 12.5491V5.48662C9.50045 5.21047 9.7243 4.98662 10.0004 4.98662ZM10.0004 14.2366C9.58623 14.2366 9.25045 14.5724 9.25045 14.9866C9.25045 15.4008 9.58623 15.7366 10.0004 15.7366C10.4147 15.7366 10.7504 15.4008 10.7504 14.9866C10.7504 14.5724 10.4147 14.2366 10.0004 14.2366Z"
        fill="#BD0000"
      />
    </svg>
  );
}

export default memo(WarningIcon);
